import { useMutation } from "@tanstack/react-query";
import { login, adminLogin } from "../../api/auth/auth.api.js";
import { useAuthStore } from "../../store/authStore.js";

export const useLoginMutation = (role) => {
  const { setUser, setToken, setRole } = useAuthStore();

  const mutationFn = role === "admin" ? adminLogin : login;

  return useMutation({
    mutationFn: (credentials) => mutationFn(credentials),

    onSuccess: (data) => {
      const { access_token, user, role } = data || {};

      if (access_token) {
        localStorage.setItem("authToken", access_token);
        setToken(access_token);
      }

      if (user) {
        setUser(user);
      }

      if (user?.role) {
        setRole(user?.role);
      }
    },

    onError: (error) => {
      console.error("Login failed:", error?.message || error);
    },
  });
};
